const config = {
    version: "26.03.09-1",
    homePath: "/",
    // homePath: "http://localhost:8088/",
    proxyPath: "http://localhost:6030/",
    locale: "ru",
    margin: 1,
    headerHeight: 50,
    innerHeight: 20,
    footerHeight: 10,
    topHeight: 30,
    leftWidth: 180,
    messageTimeout: 500,
    dialogBodyPadding: 0,
    relationPageSize: 50,
    devMode: true,
    labelMode: true,
    map: {fontSize: '12px'},
    ui: 'normal raised round',
    homeCenter: [11300000, 8600000],
    homeZoom: 8,
    topos: ['osm', 'esri','biotopsmap'],
    useApplyButton: true
};
window.IasConfig = config;
